import React from "react";
import { PHASES } from "../../constants";
import type { MemosMap, ProcessedEntry } from "../../types";

export interface PhaseRailMatter {
  id: string;
  name: string;
  phase: string;
}

export interface PhaseRailProps {
  emails?: unknown[];
  processed: ProcessedEntry[];
  memos: MemosMap;
  matters: PhaseRailMatter[];
}

/* Phase rail (T7) — buckets processed emails into the 5-phase deal lifecycle.
   Phase advances at milestones (term sheet signed, signing, closing); emails
   before a milestone fall into the prior phase. */
export function PhaseRail({ processed, memos }: PhaseRailProps): JSX.Element | null {
  if (!processed || processed.length === 0) return null;
  let cur = 0;
  const buckets: Record<string, number> = {
    Setup: 0,
    Terms: 0,
    Documentation: 0,
    "Pre-Closing": 0,
    "Post-Closing": 0,
  };
  processed.forEach((p) => {
    const here = PHASES[cur];
    if (
      here === "Setup" &&
      p.R &&
      p.R.facts &&
      p.R.facts.some((f) => /Round|Pre-money|Liquidation|Option/i.test(f[0]))
    ) {
      cur = 1;
    }
    buckets[PHASES[cur]]++;
    const phaseHit = ((p.R && p.R.checks) || []).find((c) => c.id === "phase");
    if (phaseHit) {
      if (/Documentation/i.test(phaseHit.out)) cur = Math.max(cur, 2);
      else if (/Pre-Closing/i.test(phaseHit.out)) cur = Math.max(cur, 3);
      else if (/Post-Closing/i.test(phaseHit.out)) cur = Math.max(cur, 4);
    }
  });
  let active = cur;
  if (memos) {
    Object.values(memos).forEach((m) => {
      const idx = PHASES.indexOf(m.phase);
      if (idx > active) active = idx;
    });
  }
  return (
    <div className="phaserail" role="group" aria-label="Deal phase rail">
      {PHASES.map((p, i) => {
        const cls = i < active ? "done" : i === active ? "on" : "";
        return (
          <div
            key={p}
            className={"pseg " + cls}
            title={p + " · " + buckets[p] + " email" + (buckets[p] === 1 ? "" : "s")}
          >
            <span className="pnum">{i + 1}</span>
            <span>{p}</span>
            {buckets[p] > 0 && <span className="pcount">{buckets[p]}</span>}
          </div>
        );
      })}
    </div>
  );
}
